
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 35 35","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M34 17.5C34 26.613 26.613 34 17.5 34S1 26.613 1 17.5 8.387 1 17.5 1 34 8.387 34 17.5z"}}),_c('path',{attrs:{"d":"M11 18.224l4.64 3.515a1.282 1.282 0 001.835-.302L24 12"}})])])
          )
        }
      }
    